import { notEmpty } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import {
  ArticleDateContainer,
  AuthorNameContainer,
  AuthorNameContainerLabel,
  AuthorNameWrapper,
  Container,
  StyledAuthorName,
} from "scmp-app/components/article/article-render/style-article/style-article-author-block/styles";
import { formatInTimeZone, toISOString } from "scmp-app/lib/utils";
import type { styleArticleAuthorBlockArticle$key } from "scmp-app/queries/__generated__/styleArticleAuthorBlockArticle.graphql";

export type Props = {
  className?: string;
  reference: styleArticleAuthorBlockArticle$key;
};

export const StyleArticleAuthorBlock: FunctionComponent<Props> = ({
  className,
  reference: reference_,
}) => {
  const article = useFragment(
    graphql`
      fragment styleArticleAuthorBlockArticle on Article {
        createdDate
        publishedDate
        authors {
          ...authorNameAuthor
          entityId
        }
      }
    `,
    reference_,
  );

  if (!article) return null;
  const dateFormat = "MMM d , yyyy";
  const publishedDate = notEmpty(article.publishedDate)
    ? article.publishedDate
    : article.createdDate;

  const renderAuthorsName = () => {
    if (!notEmpty(article.authors)) return null;

    return (
      <AuthorNameContainer $isMultipleAuthor={article.authors.length > 1}>
        <AuthorNameContainerLabel>STORY</AuthorNameContainerLabel>
        {article.authors.map(author => {
          if (!author) return null;

          return (
            <AuthorNameWrapper key={author.entityId}>
              <StyledAuthorName reference={author} />
            </AuthorNameWrapper>
          );
        })}
      </AuthorNameContainer>
    );
  };

  return (
    <Container className={className}>
      {renderAuthorsName()}
      <ArticleDateContainer>
        <time dateTime={publishedDate ? toISOString(publishedDate) : undefined}>
          {publishedDate && formatInTimeZone(publishedDate, dateFormat)}
        </time>
      </ArticleDateContainer>
    </Container>
  );
};
